import { Badge, Flex, InternalAccessor, Spacing, TableCellContent, TableColumn } from '@billy/design-system'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { ContactPersonsTableStaticActions } from '../elements/ContactPersonsTableStaticActions'
import { ContactPersonsTableRow } from '../types/contactPersonsTable'

export const useContactPersonsTableColumns = (): TableColumn<ContactPersonsTableRow>[] => {
  const { t } = useTranslation()

  return useMemo(
    () => [
      {
        accessor: 'name',
        Header: t('contact.detail.contact_persons.columns.name'),
        truncate: true,
        Cell: ({ row, data }) => {
          const { name, isPrimary } = data[row.id] as ContactPersonsTableRow
          return (
            <TableCellContent truncate>
              <Flex alignItems="center" gap={Spacing.S6}>
                {name}
                {isPrimary && <Badge color="accent">{t('contact.detail.contact_persons.primary')}</Badge>}
              </Flex>
            </TableCellContent>
          )
        },
      },
      {
        accessor: 'email',
        Header: t('contact.detail.contact_persons.columns.email'),
        truncate: true,
      },
      {
        accessor: InternalAccessor.StaticActions,
        Header: '',
        Cell: ({ row, data }) => {
          const { staticActions, id } = data[row.id] as ContactPersonsTableRow
          return <ContactPersonsTableStaticActions contactPersonId={id} staticActions={staticActions} />
        },
        sortable: false,
      },
    ],
    [t],
  )
}
